import React, { useEffect } from "react";
import { createStyles, makeStyles, Theme } from "@material-ui/core/styles";
import BackgroundSelectionHeader from "./BackgroundSelectionHeader/BackgroundSelectionHeader";
import BackgroundThumbnail from "./BackgroundThumbnail/BackgroundThumbnail";
import Drawer from "@material-ui/core/Drawer";
import { backgroundConfig } from "../VideoProvider/useBackgroundSettings/useBackgroundSettings";
import useVideoContext from "../../hooks/useVideoContext/useVideoContext";

const useStyles = makeStyles((theme: Theme) =>
  createStyles({
    drawer: {
      display: "flex",
      width: theme.rightDrawerWidth,
      height: "100%"
    },
    thumbnailContainer: {
      display: "flex",
      flexWrap: "wrap",
      padding: "5px",
      overflowY: "auto"
    }
  })
);

// Define a function to check if virtual background assets are accessible
async function checkVirtualBackgroundAssets() {
  const virtualBackgroundAssets =
    process.env.REACT_APP_VIRTUAL_BACKGROUND_PATH || "/virtualbackground";
  console.log(
    "Background dialog: Checking virtual background assets path:",
    virtualBackgroundAssets
  );

  try {
    // Check for the critical WASM files
    const filesToCheck = ["segm.wasm", "selfie_segmentation.tflite"];

    for (const file of filesToCheck) {
      const fileUrl = `${virtualBackgroundAssets}/${file}`;
      console.log(`Background dialog: Checking file ${fileUrl}`);

      try {
        const response = await fetch(fileUrl, { method: "HEAD" });
        console.log(
          `Background dialog: File ${file} ${
            response.ok ? "is accessible" : "is NOT accessible"
          } (${response.status})`
        );
      } catch (err) {
        console.error(`Background dialog: Error checking file ${file}:`, err);
      }
    }
  } catch (err) {
    console.error("Background dialog: Error in assets check:", err);
  }
}

export default function BackgroundSelectionDialog() {
  const classes = useStyles();
  const {
    isBackgroundSelectionOpen,
    setIsBackgroundSelectionOpen,
    backgroundSettings,
    setBackgroundSettings
  } = useVideoContext();

  useEffect(() => {
    if (isBackgroundSelectionOpen) {
      // Check assets when dialog opens
      checkVirtualBackgroundAssets();
    }
  }, [isBackgroundSelectionOpen]);

  const images = backgroundConfig.images;
  const imageNames = backgroundConfig.imageNames;

  return (
    <Drawer
      variant="persistent"
      anchor="right"
      open={isBackgroundSelectionOpen}
      transitionDuration={0}
      classes={{
        paper: classes.drawer
      }}
    >
      <BackgroundSelectionHeader
        onClose={() => setIsBackgroundSelectionOpen(false)}
      />
      <div className={classes.thumbnailContainer}>
        <BackgroundThumbnail thumbnail="none" name="None" />
        <BackgroundThumbnail thumbnail="blur" name="Blur" />
        {images.map((image, index) => (
          <BackgroundThumbnail
            thumbnail="image"
            imagePath={image}
            name={imageNames[index]}
            index={index}
            key={index}
          />
        ))}
      </div>
    </Drawer>
  );
}
